import { StyleSheet } from "react-native"

const styles = StyleSheet.create({
    borderedStyle: {
        borderWidth: 1,
        borderColor: "#DDDDDD",
        borderRadius: 12,
        padding: 16,
        paddingTop: 6
    }
})
export default styles;